import React from 'react'

import { A, Avatar, Div, P } from '@driftt/tide-core'

import './style.css'

interface IProps {
  endUser: {
    name?: string
    email?: string
    title?: string
    id?: string
  }
  fallbackName?: string
}

const LeadCell = ({ endUser = {}, fallbackName = 'Site visitor' }: IProps) => (
  <Div className="lead-cell">
    <Div className="lead-avatar">
      {endUser.id ? (
        <A href={`/contacts/details/${endUser.id}`} target="_self">
          <Avatar user={endUser} />
        </A>
      ) : (
        <Avatar user={endUser} />
      )}
    </Div>
    <Div>
      {endUser.id ? (
        <A
          href={`/contacts/details/${endUser.id}`}
          target="_self"
          className="lead-cell-name"
          data-private
        >
          {endUser.name || endUser.email || fallbackName}
        </A>
      ) : (
        <Div data-private className="lead-cell-name">
          {endUser.name || endUser.email || fallbackName}
        </Div>
      )}
      <P className="lead-cell-title">{endUser.title}</P>
    </Div>
  </Div>
)

export const renderLeadCell = (endUser, fallbackName?: string) => (
  <LeadCell endUser={endUser} fallbackName={fallbackName} />
)

export default LeadCell
